var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 12,
    viewBox: "0 0 28 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8643 4.34014H2.51432C1.59766 4.34014 0.847656 5.09014 0.847656 6.0068C0.847656 6.92347 1.59766 7.67347 2.51432 7.67347H20.8643V10.6568C20.8643 11.4068 21.7643 11.7735 22.281 11.2401L26.9143 6.59014C27.231 6.2568 27.231 5.74014 26.9143 5.4068L22.281 0.756804C21.7643 0.22347 20.8643 0.606803 20.8643 1.34014V4.34014Z",
    fill: "#F2A200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateArrow);
export default __webpack_public_path__ + "static/media/update_arrow.5617066b45ff008a9d3038a03e62faf8.svg";
export { ForwardRef as ReactComponent };